class AccordionGroup extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleTriggerKeydown = this.handleTriggerKeydown.bind(this)

    this.els.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger)

      if (triggerEl.tagName !== 'BUTTON') {
        this.listeners.add(triggerEl, 'keydown', this.handleTriggerKeydown)
      }
    })
  }

  handleTriggerKeydown (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return

    event.preventDefault()
    event.currentTarget.click()
  }

  syncTriggerState (triggerEl, isExpanded) {
    triggerEl.setAttribute('aria-expanded', isExpanded ? 'true' : 'false')

    const itemEl = triggerEl.closest(this.els?.item?.selector)
    itemEl?.setAttribute('aria-expanded', isExpanded ? 'true' : 'false')

    const controlsId = triggerEl.getAttribute('aria-controls')
    const controlledEl = controlsId
      ? document.getElementById(controlsId)
      : triggerEl
        .closest(this.els?.item?.selector)
        ?.querySelector(this.els?.content?.selector)

    if (!controlledEl) return

    controlledEl?.setAttribute('aria-hidden', isExpanded ? 'false' : 'true')
  }

  handleTrigger (event) {
    const itemEl = event.target.closest(this.els?.item?.selector)
    const triggerEl = event.currentTarget

    if (this.dataset.type === 'oneopen') {
      this.els?.item?.elements.forEach((tempEl) => {
        if (tempEl !== itemEl) {
          const siblingTriggerEl = tempEl.querySelector(
            this.els?.trigger?.selector,
          )

          if (siblingTriggerEl) {
            this.syncTriggerState(siblingTriggerEl, false)
            tempEl.setAttribute('data-expanded', 'false')
          }
        }
      })
    }

    const currentState = triggerEl.getAttribute('aria-expanded') === 'true'
    const nextState = !currentState

    this.syncTriggerState(triggerEl, nextState)
    itemEl?.setAttribute('data-expanded', nextState ? 'true' : 'false')
  }
}

if (!customElements.get('accordion-group')) {
  customElements.define('accordion-group', AccordionGroup)
}
